"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _composeReactRefs = _interopRequireDefault(require("@seznam/compose-react-refs"));
var _mixins = require("../../styles/mixins");
var _MockPrintInput = _interopRequireDefault(require("./MockPrintInput"));
var _HBInput = require("./HBInput.styles");
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _excluded = ["size", "customTheme", "width", "scope", "onBlur", "onKeyDown", "onEnterKey", "blurOnEnterKey", "onFocus", "selectOnFocus", "testIdName", "testId", "required", "$showBorderWhenRequired"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBInput = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    customTheme = props.customTheme,
    width = props.width,
    _props$scope = props.scope,
    scope = _props$scope === void 0 ? 'system' : _props$scope,
    onBlur = props.onBlur,
    onKeyDown = props.onKeyDown,
    onEnterKey = props.onEnterKey,
    blurOnEnterKey = props.blurOnEnterKey,
    onFocus = props.onFocus,
    selectOnFocus = props.selectOnFocus,
    testIdName = props.testIdName,
    testId = props.testId,
    required = props.required,
    _props$$showBorderWhe = props.$showBorderWhenRequired,
    $showBorderWhenRequired = _props$$showBorderWhe === void 0 ? false : _props$$showBorderWhe,
    baseProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var name = baseProps.name,
    id = baseProps.id;
  var innerRef = (0, _react.useRef)(null);
  var lastOnBlur = (0, _react.useRef)(null);
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'input',
    componentName: 'HBInput'
  });
  var _useState = (0, _react.useState)(!!props.defaultValue || !!props.value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    hasValue = _useState2[0],
    setHasValue = _useState2[1];
  var handleFocus = function handleFocus(ev) {
    if (selectOnFocus) {
      ev.currentTarget.select();
    }
    if (typeof onFocus === 'function') {
      onFocus(ev);
    }
  };
  var handleKeyDown = function handleKeyDown(ev) {
    if (ev.keyCode === 13) {
      if (blurOnEnterKey) {
        ev.currentTarget.blur();
      }
      if (typeof onEnterKey === 'function') {
        onEnterKey(ev);
      }
    }
    if (typeof onKeyDown === 'function') {
      onKeyDown(ev);
    }
  };
  (0, _react.useEffect)(function () {
    if (innerRef != null && innerRef.current != null) {
      if (lastOnBlur.current != null) {
        innerRef.current.removeEventListener('blur', lastOnBlur.current);
      }
      var newOnBlur = function newOnBlur(ev) {
        var _innerRef$current;
        onBlur === null || onBlur === void 0 || onBlur(ev);
        setHasValue(!!((_innerRef$current = innerRef.current) !== null && _innerRef$current !== void 0 && _innerRef$current.value));
      };
      innerRef.current.addEventListener('blur', newOnBlur);
      lastOnBlur.current = newOnBlur;
    }
  }, [innerRef, onBlur]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StyledInput, (0, _extends2["default"])({}, baseProps, {
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    "data-testid": finalTestId,
    ref: (0, _composeReactRefs["default"])(ref, innerRef),
    size: size,
    customTheme: customTheme,
    scope: scope,
    width: width,
    $showBorderWhenRequired: !!required && !!$showBorderWhenRequired && !hasValue
  })), /*#__PURE__*/_react["default"].createElement(_MockPrintInput["default"], (0, _extends2["default"])({}, baseProps, {
    size: size,
    customTheme: customTheme,
    scope: scope,
    width: width
  })));
});
var _default = exports["default"] = HBInput; // -------------------------------- Styles -------------------------------- //
var StyledInput = (0, _styledComponents["default"])(_HBInput.Input).withConfig({
  displayName: "HBInput__StyledInput",
  componentId: "sc-54ca4x-0"
})(["&&{", "}"], _mixins.hideInPrint);
//# sourceMappingURL=HBInput.js.map